export const VARIANT_IDENTIFIER_SKU = 'sku';
export const VARIANT_IDENTIFIER_UPC = 'upc';
export const VARIANT_IDENTIFIER_EAN = 'ean';
export const VARIANT_IDENTIFIER_ID_IN_SOURCE = 'id_in_source';
export const VARIANT_IDENTIFIER_RETAILER_SKU = 'retailer_sku';

export const VariantIdentifierDisplayName = {
  [VARIANT_IDENTIFIER_SKU]: 'SKU',
  [VARIANT_IDENTIFIER_UPC]: 'UPC',
  [VARIANT_IDENTIFIER_EAN]: 'EAN',
  [VARIANT_IDENTIFIER_ID_IN_SOURCE]: 'Id In Source',
  [VARIANT_IDENTIFIER_RETAILER_SKU]: 'Retailer SKU',
};

export function variantIdentifier(variant) {
  if (variant.sku) {
    return VARIANT_IDENTIFIER_SKU;
  } else if (variant.upc) {
    return VARIANT_IDENTIFIER_UPC;
  } else if (variant.ean) {
    return VARIANT_IDENTIFIER_EAN;
  } else if (variant.id_in_source) {
    return VARIANT_IDENTIFIER_ID_IN_SOURCE;
  } else if (variant.retailer_sku) {
    return VARIANT_IDENTIFIER_RETAILER_SKU;
  }
}
